const SIZES = {
  sm: { the: "text-[0.6rem]", name: "text-[1.1rem] sm:text-[1.2rem]", line: "w-8 mt-1.5", italy: "text-[0.5rem] mt-1" },
  lg: { the: "text-sm", name: "text-3xl sm:text-4xl", line: "w-14 mt-3", italy: "text-[0.65rem] mt-2.5" },
};

export const Logo = ({ size = "sm" }) => {
  const s = SIZES[size];
  return (
    <span className="f-logo inline-flex flex-col items-center leading-none select-none whitespace-nowrap" data-testid="brand-logo">
      <span className={`${s.the} tracking-[0.32em]`}>THE</span>
      <span className={`${s.name} tracking-[0.1em] mt-[0.2em]`}>STONE EDITION</span>
      <span className={`${s.line} h-px bg-current opacity-50`} />
      <span className={`f-sans ${s.italy} tracking-[0.4em] pl-[0.4em]`}>ITALY</span>
    </span>
  );
};
